import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const LogoutIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="30" height="30" viewBox="0 0 24 24">
      <path d="M18.319,9.96a8.1,8.1,0,1,1-11.455,0" transform="translate(0 -2.785)" fill="none" />
      <path d="M18,3v9" transform="translate(-5.404 0)" />
    </SvgIcon>
  );
};
